import { Brand } from '@blade/std-lib'

export const FavoriteIdTypeId = 'tradebot-tma/FavoriteId'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type FavoriteIdTypeId = typeof FavoriteIdTypeId

export type FavoriteId = Brand.Branded<string, FavoriteIdTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FavoriteId = Brand.nominal<FavoriteId>()
